import { AlignmentType, Paragraph, TextRun } from "docx";

export function introductionText1Network(certInNetworkCustomerName) {
    return new Paragraph({
        spacing: { line: 376 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION security testing team performed Internal Network Vulnerability Assessment and Penetration Testing Report of ${certInNetworkCustomerName}. The overall objective and goal of this engagement was to:`,
                size: 24,
                color: "000000",
                font: "Arial",
                bold: false,
                italics: false
            })

        ]
    })
}

export function introductionBulletOneNetwork(certInNetworkCustomerName) {
    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },
        spacing: { line: 400, before:600 },
        children: [
            new TextRun({
                text: "Identify Vulnerabilities in Internal Network of"+" "+certInNetworkCustomerName,
                size: 24,
                font: "Arial",
                bullet: { level: 0 },
                color: '000000',
                italics: false,
                bold: false
            })
        ]
    })
}

